export default __webpack_public_path__ + "static/media/interev.96fdbe72.png";